import React from "react";

export const CourseBundleCircleIcon = (props) => {
  return (
    <svg
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="32.3925"
        cy="31.8925"
        r="31.2525"
        fill="white"
        stroke="#E4E4E4"
        strokeWidth="1.28"
      />
      <g clipPath="url(#clip0_6181_15561)">
        <path
          d="M28.3477 48.8912C26.673 48.5114 25.0647 47.8829 23.5762 47.0269"
          stroke="#18428E"
          strokeWidth="2.34791"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.0439 15.1162C39.8691 15.9898 43.2844 18.1363 45.7305 21.2041C48.1767 24.2719 49.5088 28.0794 49.5088 32.003C49.5088 35.9267 48.1767 39.7341 45.7305 42.802C43.2844 45.8698 39.8691 48.0162 36.0439 48.8899"
          stroke="#18428E"
          strokeWidth="2.34791"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.9174 41.8034C16.8678 40.2786 16.0707 38.5947 15.5566 36.8164"
          stroke="#18428E"
          strokeWidth="2.34791"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.1182 29.1178C15.426 27.29 16.0186 25.5584 16.8498 23.9711L17.1749 23.3843"
          stroke="#18428E"
          strokeWidth="2.34791"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.3979 17.7251C24.1981 16.4859 26.2177 15.6005 28.3488 15.1162"
          stroke="#18428E"
          strokeWidth="2.34791"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.4238 32.0072L30.2718 35.8551L37.9677 28.1592"
          stroke="#18428E"
          strokeWidth="2.34791"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6181_15561">
          <rect
            width="46.1756"
            height="46.1756"
            fill="white"
            transform="translate(9.10889 8.91211)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
